import script from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlay.vue?vue&type=style&index=0&id=1c24fe68&lang=scss&scoped=true"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c24fe68"]])

export default __exports__